module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/suns-house_access_07-c161f4a0eaeb2c0979aefdcf2755766b.jpg";